"use client";

const $$splitComponentImporter = () => import('/home/runner/work/VideoServerGolang/VideoServerGolang/web_src/routes/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});